//import Phaser from 'phaser'
var Phaser = require('phaser');
//import { GameScene } from "./gameScene.js";
var gamescene = require('./gameScene.js');

import './styles.css';
 
const config = {
    type: Phaser.AUTO,
    width: 192,
    height: 160,
    physics: {
        default: 'arcade',
        arcade: {
            x: 0,
            y: -4000,
            width: 192,
            height: 4160-2,
            gravity: { y: 512 },
            checkCollision: {
                        up: true,
                        down: true,
                        left: true,
                        right: true
                    },
            debug: false
        }
    },
    pixelArt: true,
    zoom: 4,
    loader: {
        //baseURL: "https://labs.phaser.io",
        //baseURL: "localhost:1234/",
        //crossOrigin: "anonymous"
    },
    scene: gamescene.GameScene
};
 
new Phaser.Game(config);